/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useEffect, useState, useRef, RefObject } from 'react';
import { ProductMenuItem } from '../types/product-menu-item';
import { ProductMenuError } from '../types/product-menu-error';
import { IWidgetLoader, WidgetLoader } from '@revenuewell/logic-widget-loader';
import './product-menu-loader.scss';

export interface IProductMenuLoaderProps
  extends React.PropsWithChildren<unknown> {
  apiUrl: string;
  accessToken: string;
  locationId: number;
  customerId: number;
  userName: string;
  onError?(error: ProductMenuError): void;
  onReady?(): void;
  onLogout?(): void;
  selectedItem?: ProductMenuItem;
  visible?: boolean;
  focused?: boolean;
}

export const ProductMenuLoader: React.FC<IProductMenuLoaderProps> = ({
  apiUrl,
  accessToken,
  locationId,
  customerId,
  userName,
  onError,
  onReady,
  onLogout,
  selectedItem,
  visible,
  focused
}) => {
  const containerId = 'rw-product-menu';
  const widgetLoaderRef = useRef<IWidgetLoader>();
  const [isReady, setIsReady] = useState<boolean>(false);
  const hash = Date.now();

  useEffect(() => {
    if (isReady) {
      const container = document.getElementById(containerId);
      container?.classList?.add('focused');
    }
  }, [isReady]);

  const onMessageReceive = (name: string, payload: any) => {
    switch (name) {
      case 'ProductMenu.ConfigRequest':
        onMenuConfigRequest();
        setIsReady(true);
        if (onReady) {
          onReady();
        }
        break;
      case 'ProductMenu.SignOut': {
        if (onLogout) {
          onLogout();
        }
        break;
      }
    }
  };

  const onMenuConfigRequest = async () => {
    widgetLoaderRef?.current?.postMessage('ProductMenu.ConfigResponse', {
      name: 'ProductMenu.ConfigResponse',
      config: {
        accessToken: accessToken,
        locationId: locationId,
        customerId: customerId,
        userName: userName,
        selectedItem: selectedItem
      }
    });
  };

  return (
    <WidgetLoader
      name="ProductMenu"
      ref={widgetLoaderRef as RefObject<WidgetLoader>}
      dist={{
        styleUrl: `${apiUrl}/product-menu.css?_=${hash}`,
        scriptUrl: `${apiUrl}/product-menu.js?_=${hash}`
      }}
      lifecycle={{
        onLoad: () =>
          widgetLoaderRef?.current?.postMessage('ProductMenu.Start', {
            id: containerId
          }),
        onError: (error) => onError && onError(error),
        onMessageReceive: (name, payload) => onMessageReceive(name, payload)
      }}
      element={{
        id: containerId,
        className: `product-menu-container ${focused ? 'focused' : ''} ${
          visible ? 'visible' : ''
        }`
      }}
    />
  );
};
